import $ from 'jquery';

export function jQuery(): typeof $ {
    if (typeof $ === 'function') {
        return $;
    } else {
        if (typeof $ === 'object' && 'default' in $) {
            //@ts-ignore
            return $.default;
        }
        //@ts-ignore
        if (typeof window.$ === 'function') {
            //@ts-ignore
            return window.$;
        }
    }
}